export const getProductVariantName = (fullVariantName, addWordBreakOpportunities = false) => {
  if (Object.prototype.toString.call(fullVariantName) !== '[object String]') {
    // the param is not a string, return it
    return fullVariantName;
  }

  const newName = fullVariantName.match(/^(.*)( - )(.*)$/);

  // check if we got a valid variant name
  if (newName && newName.length === 4 && `${newName[1]}${newName[2]}${newName[3]}` === fullVariantName) {
    // looks like we got a valid variant name, returning it!

    if (addWordBreakOpportunities) {
      // add WBO character after every forward slash
      return newName[3].replace(/\//g, '/\u200B');
    }

    return newName[3];
  }
  // something went wrong in our validation, returning original name...
  return fullVariantName;
};



// WEBPACK FOOTER //
// ./src/util/getProductVariantName.js